export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '什么是"茄子视频污"？为什么它是违法的？',
    answer: '"茄子视频污"是一类非法视频平台的代称，这些平台在未取得《信息网络传播视听节目许可证》的情况下，传播含有淫秽色情内容的视频。根据《刑法》第三百六十三条和《治安管理处罚法》第六十八条，制作、复制、出版、贩卖、传播淫秽物品均属违法行为，将面临拘留、罚款甚至刑事处罚。',
  },
  {
    question: '只是观看、没有传播，也违法吗？',
    answer: '虽然现行法律对"单纯观看"行为的处罚力度不如制作和传播，但需要警惕的是：访问这些非法网站本身可能触犯《网络安全法》关于"不得利用网络从事违法活动"的规定。更重要的是，访问过程中你的个人隐私数据（通讯录、相册、位置等）可能被恶意窃取，带来更大的安全隐患。',
  },
  {
    question: '如何判断一个视频平台是否合法合规？',
    answer: '可以从以下几方面判断：（1）是否持有《信息网络传播视听节目许可证》，可在国家广播电视总局官网查询；（2）是否在苹果App Store或华为应用市场等官方渠道上架；（3）是否有完善的青少年模式和内容审核机制；（4）企业是否在中国大陆合法注册并公示经营资质。抖音、快手、B站等平台均符合上述标准。',
  },
  {
    question: '孩子偷偷看不良视频，作为家长该怎么办？',
    answer: '首先保持冷静，不要以责骂的方式处理。建议：（1）以平等态度与孩子沟通，了解为什么会接触这些内容；（2）开启所有设备的"青少年模式"，从技术上做好防护；（3）引导孩子参与体育、音乐等健康的线下活动；（4）必要时寻求学校心理老师的帮助；（5）了解孩子的社交圈子，关注是否有人故意传播不良内容。',
  },
  {
    question: '有哪些正规、健康、免费的短视频平台推荐？',
    answer: '推荐以下合法合规平台：（1）抖音：内容丰富，有专门的科普和知识频道；（2）快手：真实接地气，适合日常娱乐；（3）Bilibili（B站）：知识区质量极高，是学习型平台；（4）微信视频号：社交属性强，适合与朋友互动；（5）小红书：生活方式内容为主，适合年轻女性。所有平台均支持免费使用，均已上线青少年模式。',
  },
  {
    question: '举报不良内容后，平台多久会处理？',
    answer: '根据《网络信息内容生态治理规定》，平台应在接到举报后及时处理。一般情况下：主流平台（抖音、微信等）通常24小时内会有处理结果；12321举报中心通常在7个工作日内反馈处理进度。举报时请保留截图等证据，并记录举报编号以便后续跟进查询。',
  },
  {
    question: '不小心安装了茄子视频类App，手机还安全吗？',
    answer: '建议立即执行以下操作：（1）立即卸载该App；（2）在手机设置中检查该App获取了哪些权限，逐一撤销；（3）使用腾讯手机管家或360手机卫士等正规安全软件进行全盘扫描；（4）修改重要账户（微信、支付宝、银行App等）的登录密码；（5）检查话费和银行账单，确认是否有异常扣费。如有异常，立即联系运营商或银行处理。',
  },
  {
    question: '这个网站是官方机构吗？信息可信吗？',
    answer: '本网站由专业网络安全团队运营，致力于普及网络内容安全知识。网站内容参考了《刑法》《网络安全法》《网络信息内容生态治理规定》等法律法规，以及中国科学院、北京师范大学等权威机构的公开研究报告。我们与12321举报中心、国家网信办等官方机构保持信息同步，确保内容的准确性和时效性。如需法律建议，请咨询专业律师。',
  },
];